import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Link,
  Backdrop,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import { loginAdmin } from "../../redux/action/admin";

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const businessName = queryParams.get("businessName") || "";
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const formatBusinessName = (name: string): string => {
    return name
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]/g, "");
  };

  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const handleSubmit = async () => {
    setError("");
    setIsLoading(true);

    try {
      const registerData = { email, password };
      await dispatch<any>(loginAdmin(registerData))
        .then(unwrapResult)
        .then((res: any) => {
          console.log(res, "logim admin");
          localStorage.setItem("AdminToken", res);
        });
      navigate("/admin-dashboard");
    } catch (err: any) {
      setError(err || "Failed to register");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh", 
          height: "100%", 
          background: "linear-gradient(-45deg, #ee7752, #e73c7e, #23d5ab, #23a6d5)",
          backgroundSize: "400% 400%",
          animation: "gradientAnimation 20s ease infinite",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: isMobile ? 1 : 3,
          overflow: "hidden", 
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            maxWidth: 500,
            width: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 3,
            p: isMobile ? 2 : 3,
            mx: isMobile ? 1 : 3,
            textAlign: "center",
            position: "relative",
            zIndex: 1,
            overflowY: "auto", 
            maxHeight: "90vh",
            boxSizing: "border-box",
          }}
        >
          {isLoading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
              onClick={() => {
                setIsLoading(true);
              }}
            >
              <Box sx={{ width: "50%" }}>
                <LinearProgress />
                <Typography
                  fontSize={16}
                  fontWeight={500}
                  textAlign="center"
                  mt={1}
                >
                  {loadingMessage}
                </Typography>
              </Box>
            </Backdrop>
          )}
          <Typography variant="h4" gutterBottom>
            Admin Login
          </Typography>

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />

          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ width: "100%" }}
          >
            Login
          </Button>
        </Box>
      </Box>
      <style>
        {`
          @keyframes gradientAnimation {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}
      </style>
    </>
  );
};

export default AdminLogin;
